import React, { Component, useEffect, useState, useRef } from "react";
import DialCode from './PaymentDetails/DialCode';
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import { LoginAdminTOAgentConfirmation} from './axios';
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./AgentSignup.css";


export default function AgentLoginConfirmation() {

  const { id } = useParams();
  const email = atob(id);
  useEffect(() => {
    LoginAdminTOAgentConfirmation(email).then(
      (data) => {
        if (data == 'not_correct') {
          let text = "This is not correct.";
          if (window.confirm(text) == true) {
          }
      }else if (data == 'not_active') {
        let text = "Your Account is not activated by System Admin!";
        if (window.confirm(text) == true) {
        }
        
      }else if(data == 'not_verified'){
        let text = "You have not yet verified with your email!";
        if (window.confirm(text) == true) {
        }
        
      } else {
       // const { cookies } = this.props;
         // this.setState({ customerDetails: data });

          let Verified = '';
          if (data.verified == 1) {
              Verified = true;
          }

          const dataSearch = {
              first_name: data.first_name,
              last_name: data.last_name,
              email: data.email,
              country_code: data.country_code,
              verified: Verified,
              uid: data.id
          }

          let JsonData = JSON.stringify(dataSearch);

          localStorage.setItem('userDetails', JsonData);
        
         // window.location.reload(true);
         var base_url = window.location.origin;
         window.location.href = base_url+"/home";
         this.setState({ btnloader: false });
        // history.push("/home");
        // return <Redirect to='/home'  />
      }
      },
      (error) => {}
    );
       
        //    //window.addEventListener("scroll", this.handleScroll);  
}, []);


    return (
      <div id="login">

      {/* <figure> <a href="/">
        <img src="images/logo/seyLogo.png" alt="Holiday Seychelles" className="logo_sticky" />
        </a>
      </figure> <br/> */}
      {/* <div style={{textAlign: 'center', width: '700px', margin: 'auto'}}>
                    <h3 style={{marginBottom: '3%'}}>Thank You</h3>
              <p style={{fontSize: '16px', fontWeight: '500'}}>Your account is verified. The account will be activated with 24 hours. 
              In case, if you do not receive any communication from our side <b>call us at</b>  <a href="tel://2484376668"><i class="fa fa-phone" aria-hidden="true"></i> +248 437 6666</a> or<br></br> <b>email to us</b> on   <a href=" info@seychelles-holidays.travel"><i class="fa fa-envelope-o" aria-hidden="true"></i> info@holidays-seychelles.com</a></p>
 
  <div class="btn btn-primary" style={{color: '#fff',
    backgroundColor: '#ed9853',
    borderColor: '#ec8c51',
    cursor: 'pointer', marginTop: '15px'}}><strong><a href="/agentlogin" style={{color:'#fff'}}>Go To Login</a></strong></div>
</div> */}
    

</div>
        );
   
}